module.exports = __webpack_public_path__ + "img/contacto.66faafde.webp";